module.exports = __webpack_public_path__ + "static/media/S4N8-4.68e5d687.svg";